<template>
  <div class="provincias">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :pais="pais"
          @filtrar="filtrar">
        </app-filtro>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Registro de Provincias">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy" 
                :items="provincias" 
                :fields="provinciasFields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>  
                <template v-slot:cell(inactivo)="data">
                  {{ (data.item.inactivo) ? 'Si' : 'No' }}
                </template>

                <template v-slot:cell(opciones)="data" v-if="accesoABM">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="editar(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos de la Provincia</b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar" v-if="accesoABM">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from  './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'provincias/getField',
  mutationType: 'provincias/updateField',
});

export default {
  name: 'ProvinciasList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data: () => {
    return {
      provinciasFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'pais',
        },
        {
          key: 'inactivo',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center', 
        },
      ],

      tableBusy: false,
      accesoABM: false,
    }
  },
  computed: {
    ...mapFields([
      'provincias',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'pais'
    ]),
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 6: /* Director Administrativo */
      case 7: /* Asistente de Administracion */ 
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 10: /* Asistente de Logística */
      case 21: /* Responsable de Finanzas y Proveedores */
      case 22: /* Responsable de Facturacion e Impuestos */
      case 23: /* Asistente de Calidad */
        this.accesoABM = true;
        break;
    }

    this.getItems()
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.pais = filtro.pais;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('provincias/getProvincias')
        .then(() => this.tableBusy = false)
        .catch( error => this.showErrorMsj (error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ProvinciaData', 
                          params: { id: item.id }})
    },
    editar (item) {
      if (this.accesoABM) {
        this.$router.push({ name: 'ProvinciaABM', 
                            params: { id: item.id }})
      }
    },
    agregar () {
      if (this.accesoABM) {
        this.$router.push({ name: 'ProvinciaABM', 
                            params: { id: 0 }})
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
.provincias .registro table td {
  vertical-align: middle;
}
.provincias .registro table td[aria-colindex="1"] {
  width: calc(50% - 40px);
}
.provincias .registro table td[aria-colindex="2"] {
  width: 40%;
}
.provincias .registro table td[aria-colindex="3"] {
  width: 10%;
}
.provincias .registro table td[aria-colindex="4"] {
  width: 40px;
}
</style>
